import { Box } from '@/components';
import { PinpointMarker } from '@/features/comment/components/pinpoint';
import { getPinpointSceneAndFieldBySheetType } from '@/features/comment/utils/pinpoint';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import { type FC, memo } from 'react';
import { BudgetAndExecutionTable } from '../../income-and-expenditure/_components/shared/BudgetAndExecutionTable';

export const RecurringStatsTable: FC = memo(() => {
  const { id: projectId } = useId();
  const project = useProject(projectId);

  if (!project.data) {
    return null;
  }

  const fiscalYear = project.data.fiscalYear;
  const isSkippedReview = project.data.skipAdministrativeReformTeamEvaluation;

  return (
    <PinpointMarker
      pinpoint={getPinpointSceneAndFieldBySheetType({
        pinpointSheetType: isSkippedReview ? 'RS_SKIPPED_REVIEW' : 'RS',
        rs: {
          path: { project: projectId },
          field: 'rs.recurring-stats-table',
        },
        rsSkippedReview: {
          path: { project: projectId },
          field: 'rs.skippedReview.recurring-stats-table',
        },
      })}
    >
      <Box padding={16} bordered>
        <BudgetAndExecutionTable
          projectId={projectId}
          fiscalYear={fiscalYear}
        />
      </Box>
    </PinpointMarker>
  );
});
